import * as MultivariateTestingConfiguration from 'assets/core/js/module/multivariateTesting/configuration.json'

const getCookie = (name: string): string | null => {
  const match = document.cookie.match(new RegExp(`(^|; )${name}=([^;]*)`))
  return match ? decodeURIComponent(match[2] ?? '') : null
}

export default {
  getAllMultivariateTestingValues(): Record<string, string> {
    const cookieValue = getCookie('MultivariateGroups')
    if (!cookieValue) {
      return {}
    }

    const application = document.querySelector('[data-application-id]')?.getAttribute('data-application-id')

    const lines = cookieValue.split('\n')
    const result: Record<string, string> = {}

    for (const line of lines) {
      const [rawKey, rawValue] = line.split(':').map((s) => s?.trim())

      if (
        rawKey &&
        rawValue &&
        rawKey in MultivariateTestingConfiguration &&
        // biome-ignore lint/performance/noDynamicNamespaceImportAccess: unknown
        MultivariateTestingConfiguration[rawKey as keyof typeof MultivariateTestingConfiguration]
      ) {
        if (
          application &&
          // biome-ignore lint/performance/noDynamicNamespaceImportAccess: unknown
          !MultivariateTestingConfiguration[rawKey as keyof typeof MultivariateTestingConfiguration].applications.includes(application)
        ) {
          continue
        }

        // biome-ignore lint/performance/noDynamicNamespaceImportAccess: unknown
        const variableName = MultivariateTestingConfiguration[rawKey as keyof typeof MultivariateTestingConfiguration].gtmVariable
        result[variableName] = `${rawKey}.${rawValue}`
      }
    }

    return result
  },
}
